import { render, staticRenderFns } from "./AfterEvent.vue?vue&type=template&id=a276b50e&"
import script from "./AfterEvent.vue?vue&type=script&lang=js&"
export * from "./AfterEvent.vue?vue&type=script&lang=js&"
import style0 from "./AfterEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports